import * as THREE from "three";
import React from "react";
import { useSpring, a } from "@react-spring/three";
import { LineGeometry, LineMaterial, Line2 } from "three-stdlib";
import { config } from "@react-spring/core";

export const DreiLine = React.forwardRef(function Line(
  {
    points,
    color = "black",
    opacity = 1,
    vertexColors,
    lineWidth,
    dashed,
    delay = 0,
    ...rest
  },
  ref
) {
  const [line2] = React.useState(() => new Line2());
  const [lineMaterial] = React.useState(() => new LineMaterial());
  const [resolution] = React.useState(() => new THREE.Vector2(512, 512));

  const { opacity: aOpacity } = useSpring({
    from: { delta: 0 },
    to: { delta: 1, opacity: Number(opacity) },
    reset: true,
    // TODO Add option to delay animation from props
    // delay: Math.random() * 5000,
    config: { ...config.default, duration: 1000 },
    delay,
    // onChange: ({ delta }) => {
    //   if (!ref.current) return;
    //   tmpVector1.set(...end);
    //   tmpVector2.set(delta, 1, 1);
    //   tmpVector1.multiply(tmpVector2);
    // },
  });

  const lineGeom = React.useMemo(() => {
    const geom = new LineGeometry();
    const pValues = points.map((p) =>
      p instanceof THREE.Vector3 ? p.toArray() : p
    );
    geom.setPositions(pValues.flat());

    if (vertexColors) {
      const cValues = vertexColors.map((c) =>
        c instanceof THREE.Color ? c.toArray() : c
      );
      geom.setColors(cValues.flat());
    }

    return geom;
  }, [points, vertexColors]);

  React.useLayoutEffect(() => {
    line2.computeLineDistances();
  }, [points, line2]);

  React.useLayoutEffect(() => {
    if (dashed) {
      lineMaterial.defines.USE_DASH = "";
    } else {
      // Setting lineMaterial.defines.USE_DASH to undefined is apparently not sufficient.
      delete lineMaterial.defines.USE_DASH;
    }
    lineMaterial.needsUpdate = true;
  }, [dashed, lineMaterial]);

  return (
    <a.primitive dispose={undefined} object={line2} ref={ref} {...rest}>
      <primitive dispose={undefined} object={lineGeom} attach="geometry" />
      <a.primitive
        dispose={undefined}
        object={lineMaterial}
        attach="material"
        opacity={aOpacity}
        depthWrite={false}
        transparent
        color={color}
        vertexColors={Boolean(vertexColors)}
        resolution={resolution}
        linewidth={lineWidth}
        dashed={dashed}
        {...rest}
      />
    </a.primitive>
  );
});
